<template>
    <vue-custom-scrollbar>
        <div class="card-body bg-white px-4">
            <ul class="ordini my-4">
                <li
                    v-for="order in orders"
                    :key="order.fkOrdineTestata"
                >
                    <div class="box-ordini-item d-flex align-items-center justify-content-between">
                        <div>
                            <div>
                                <span class="data alert alert-dark p-1">
                                    {{ order.dataRicezioneOrdine | formatDate }}
                                </span>
                                <span class="prezzo alert alert-success p-1 ml-2">
                                    {{ parseFloat(order.totaleOrdine) | toCurrency }}
                                </span>
                            </div>
                            <div class="cliente mt-1">{{ order.ragioneSociale }}</div>
                        </div>
                    </div>
                </li>

                <li>
                    <div class="box-ordini-item align-items-center justify-content-between text-center pb-3">
                        <a
                            href="#"
                            @click="goToViewAll"
                        >{{ $t('Vedi tutti') }}</a>
                    </div>
                </li>
            </ul>
        </div>
    </vue-custom-scrollbar>
</template>

<script>
import vueCustomScrollbar from "vue-custom-scrollbar";

export default {
    name: "BackendDashboardBoxOrdini",
    props: ["orders"],

    components: { vueCustomScrollbar },

    data() {
        return {};
    },

    methods: {
        goToViewAll() {
            this.$emit("viewAllClicked");
        }
    }
};
</script>

<style scoped>
section {
    background-color: #fff;
}

div.card-body {
    padding: 0;
}

section,
div.card-body {
    height: 100%;
}
</style>
